/**
 * authService — domain wrapper around the /api/auth/v2 endpoints.
 *
 * Pages call these functions, not api.* directly.  Centralising the URLs here
 * means a backend route rename (e.g. the Module 19 cutover that drops the /v2
 * suffix) is a one-file change, not a sweep.
 */
import { api } from "../lib/api";

/**
 * POST /api/auth/v2/login
 * @returns { token, user, memberships } from the backend response.
 * @throws Error with .data.error from the backend on bad credentials.
 */
export async function login(email, password) {
  const data = await api.post("/api/auth/v2/login", { email, password });
  return {
    token: data.token,
    user: data.user,
    memberships: data.memberships || [],
  };
}

/**
 * POST /api/auth/v2/logout
 * Best-effort — even if the backend call fails (network down, token already
 * expired), the caller should still clear local state via authStore.logout().
 */
export async function logout() {
  try {
    await api.post("/api/auth/v2/logout");
  } catch {
    /* swallowed — local logout always proceeds */
  }
}

/**
 * GET /api/auth/v2/me
 * Used to revalidate a persisted token on app boot.
 * Returns the same shape as login() minus the token.
 */
export async function whoami() {
  const data = await api.get("/api/auth/v2/me");
  return {
    user: data.user,
    memberships: data.memberships || [],
  };
}
